/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {userLogin} from '../../../auth/core/_requests'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {useAuth} from '../../../auth/core/Auth'
import { useNavigate } from "react-router-dom";
import { StatusErrorMessage } from '../../../../components/widgets'
import { getErrorMessage } from '../../../../components/helpers'

const loginSchema = Yup.object().shape({
  email: Yup.string().trim()
    .email('Valid email required')
    .min(3, 'Minimum 3 symbols')
    .max(200)
    .required('Email is required'),
  password: Yup.string().trim()
    .min(2, 'Minimum 2 symbols')
    .max(20, 'Maximum 20 symbols')
    .required('Password is required'),
})

const initialValues = {
  email: '',
  password: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function SetscoLogin() {

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const {saveAuth} = useAuth()

  const formik = useFormik({
    initialValues: {...initialValues},
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
        
      setLoading(true);
      setSubmitting(true);
      setStatus('');

      await userLogin(values.email, values.password)
      .then((res) => {
        if (! (res && res?.loggedIn)) {
          setStatus((res && res?.message) ?  res.message : 'Something happened');
          return;
        }
        saveAuth( {
          email: values.email,
          password: values.password,
          loggedIn: false,
          id: res.id,
          isSetsco: true
        })
        navigate("/setsco/auth/otp");
      })
      .catch((err) => {
        const msg = getErrorMessage(err);
        if (msg.match(/401/)) {
          setStatus('Wrong username/password');
        } else {
          setStatus(msg);
        }
        saveAuth(undefined);
      }) 
      .finally(() => {
        setSubmitting(false)
        setLoading(false)
      })            
    },
  })

  return (
  <>
  <div>
    <div className="p-6 text-center" style={{marginTop: '-60px'}}>
      <img src={toAbsoluteUrl('/media/brand/Setsco_BrandSig_2D_white.png')} className="h-80px" alt='setsco' />
    </div>
    <form
      className="form w-100 w-lg-400px bg-white rounded-4 overflow-hidden"
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
      >
      <div className="bg-secondary fs-6 text-white p-6 text-center">
        CERTIFICATION APPLICATION & MANAGEMENT SYSTEM
      </div>
      <div className="p-10 d-flex flex-column gap-8 mb-4">
        <div className="text-center text-info fw-bold fs-1">
          SETSCO Sign In
        </div>

        <div className='fv-row'>
          <input
            placeholder='Username'
            {...formik.getFieldProps('email')}
            className={clsx(
              'form-control bg-transparent',
              {'is-invalid': formik.touched.email && formik.errors.email},
              {'is-valid': formik.touched.email && !formik.errors.email,}
            )}
            type='email'
            name='email'
            autoComplete='off'
          />
          {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
          )}
        </div>

        <div className='fv-row'>
          <input
            placeholder='Password'
            type='password'
            autoComplete='off'
            {...formik.getFieldProps('password')}
            className={clsx(
              'form-control bg-transparent',
              {'is-invalid': formik.touched.password && formik.errors.password,},
              {'is-valid': formik.touched.password && !formik.errors.password,}
            )}
          />
          {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
          )}
        </div>

        <StatusErrorMessage status={formik.status} />

        <div className="d-flex flex-stack flex-wrap gap-3 justify-content-start align-items-center mt-4">
          <button
            type='submit'
            id='kt_sign_in_submit'
            className='btn btn-info px-10'
            disabled={formik.isSubmitting || !formik.isValid}
          >
            {!loading && <span className='indicator-label'>Continue</span>}
            {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
            )}
          </button>
          <Link to='/setsco/auth/forgot-password' className="link-info">
            Reset/Forgot Password ?
          </Link>
          <div />
        </div>
      </div>
    </form>
  </div>
  </>
  )
}
